import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=3013c6c0&"
import script from "./Reasons.vue?vue&type=script&lang=js&"
export * from "./Reasons.vue?vue&type=script&lang=js&"
import style0 from "./Reasons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports